import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, chakra, IconButton } from '@chakra-ui/react';
import { ReactComponent as ChevronIcon } from 'resources/images/chevron-down.svg';
import { Platform } from 'types/general.types';
import { useSelector } from 'react-redux';
import { getSiderbarSettings } from 'app/store/Settings/selectors';

const Chevron = chakra(ChevronIcon);

interface NavControlsProps {
  platform?: Platform;
}

export const NavControls: React.FC<NavControlsProps> = ({ platform }) => {
  const navigate = useNavigate();

  const { width } = useSelector(getSiderbarSettings);
  return (
    <Box
      px={platform === 'darwin' ? 8 : 5}
      data-testid="nav-controls"
      whiteSpace="nowrap"
      flexShrink={0}
      pl={`calc(${width} - 56px)`}
    >
      <IconButton
        variant="text"
        width="32px"
        height="32px"
        borderRadius="full"
        onClick={() => navigate(-1)}
        size="large"
        aria-label="Go back"
        sx={{ WebkitAppRegion: 'no-drag' }}
      >
        <Chevron transform="rotate(90deg)" fill="M.60" />
      </IconButton>
      <IconButton
        variant="text"
        width="32px"
        height="32px"
        borderRadius="full"
        aria-label="Go forward"
        ml={4}
        onClick={() => navigate(1)}
        size="large"
        sx={{ WebkitAppRegion: 'no-drag' }}
      >
        <Chevron transform="rotate(-90deg)" fill="M.60" />
      </IconButton>
    </Box>
  );
};
